const SvgPasswordNotVisible = () => (
	<svg width="1em" height="1em" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M11 17.994c-4.706 0-8.182-4.307-9.462-6.164-.26-.377-.39-.565-.401-.853-.012-.288.098-.481.32-.868.516-.904 1.483-2.351 2.951-3.61m14.636 7.148a19.716 19.716 0 0 0 1.418-1.817c.26-.376.39-.565.401-.853.012-.288-.098-.48-.319-.867-1.075-1.882-4.1-6.116-9.544-6.116-1.523 0-2.9.372-3.398.558M9.24 8.563a3 3 0 1 0 4.173 4.213M3.144 1.429l18.345 14.766"
			stroke="#827D85"
			strokeWidth={1.5}
		/>
	</svg>
)

export default SvgPasswordNotVisible
